document.addEventListener('turbo:load', function(){
  if(window.location.hash) {
    $(window.location.hash)[0].scrollIntoView()
  }
})
